
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_16248_utiur_13",
  "icon": "awsui_icon_16248_utiur_45",
  "header-inner": "awsui_header-inner_16248_utiur_61",
  "disabled": "awsui_disabled_16248_utiur_70",
  "header": "awsui_header_16248_utiur_61",
  "body": "awsui_body_16248_utiur_76",
  "header-row": "awsui_header-row_16248_utiur_80",
  "description": "awsui_description_16248_utiur_93",
  "has-header": "awsui_has-header_16248_utiur_99",
  "header-button": "awsui_header-button_16248_utiur_113",
  "overlay-button": "awsui_overlay-button_16248_utiur_114",
  "variant-embedded": "awsui_variant-embedded_16248_utiur_133",
  "variant-default": "awsui_variant-default_16248_utiur_145",
  "inner-card": "awsui_inner-card_16248_utiur_246",
  "no-padding": "awsui_no-padding_16248_utiur_253",
  "icon-vertical-align-center": "awsui_icon-vertical-align-center_16248_utiur_264",
  "icon-align-end": "awsui_icon-align-end_16248_utiur_400"
};
  